export default function scrollToTop(): void {
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  });
}
